"use strict";

define('app/document/diff/document.diff.calculator',['require','exports','module','jsdiff'],function (require, exports, module) {
  'use strict';

  var JsDiff = require('jsdiff');
  var DiffCalculator = {
    calculateDiff: function calculateDiff(rightSection, leftSection) {
      var LOCAL_IMAGE_KEYWORD = "IMAGE_";
      var URL_IMAGE_KEYWORD = "IMAGE_URL_";
      var DOCSTORE_URL_PREFIX = "/rs/api/docstore/";
      var anchorHashRegEx = /__[0-9]+__/g;
      var leftDiffData = {
          hidden: [],
          changed: []
        },
        rightDiffData = {
          hidden: [],
          changed: []
        };
      var leftAnchorTags = {},
        rightAnchorTags = {};
      var hashCode = function hashCode(str) {
        var hash = 0,
          i,
          chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
          chr = str.charCodeAt(i);
          hash = (hash << 5) - hash + chr;
          hash |= 0;
        }
        return hash > 0 ? "1" + hash.toString() : "0" + Math.abs(hash).toString();
      };
      var prepForDiffing = function prepForDiffing(leftOrRight, withTags) {
        var withoutTags = withTags.replace(/<\/?(strong|em|u|del|strike|ul|ol|table|tbody|td)+[^>]*>/g, "");
        withoutTags = withoutTags.replace(/(&nbsp;)+/g, " ");
        withoutTags = withoutTags.replace(/<\/?(li|tr)+>/g, "<br>");
        withoutTags = withoutTags.replace(/<a\s+href="([^"]+)"[^>]*>([^<]+)<\/a>/g, function (ignore, url, linkText) {
          var hash = "__" + hashCode(linkText + url) + "__";
          if (leftOrRight === "left") {
            leftAnchorTags[hash] = {
              text: linkText,
              url: url
            };
          } else {
            rightAnchorTags[hash] = {
              text: linkText,
              url: url
            };
          }
          return " " + hash + " ";
        });
        var docStoreImageRegex = new RegExp("<img\\s+src=\"" + DOCSTORE_URL_PREFIX + "([0-9]+)\"[^>]*>", "g");
        withoutTags = withoutTags.replace(docStoreImageRegex, function (ignore, docId) {
          return " " + LOCAL_IMAGE_KEYWORD + docId + "_ ";
        });
        withoutTags = withoutTags.replace(/<img\s+src="([^"]+)"[^>]*>/g, function (ignore, url) {
          return " " + URL_IMAGE_KEYWORD + hashCode(url) + "_ ";
        });
        withoutTags = withoutTags.replace(/(<br>\s*)+/g, "<##>");
        return withoutTags;
      };
      var replaceLastOccurrence = function replaceLastOccurrence(str, findStr, replaceStr) {
        var n = str.lastIndexOf(findStr);
        return str.substring(0, n) + replaceStr + str.substring(n + findStr.length);
      };
      var processUnchangedAnchor = function processUnchangedAnchor(hash) {
        if (!leftAnchorTags[hash] || !rightAnchorTags[hash]) {
          throw new Error("Anchor hash not found");
        }
        var linkText = leftAnchorTags[hash].text;
        if (linkText) {
          delete leftAnchorTags.hash;
          delete rightAnchorTags.hash;
        }
        return linkText;
      };
      var insertArrayIntoArray = function insertArrayIntoArray(a1, a2, insertAt) {
        a2.splice.apply(a2, [insertAt, 0].concat(a1));
      };
      var getAllAnchorsInDiff = function getAllAnchorsInDiff(diff) {
        var anchors = diff.value.match(anchorHashRegEx);
        return anchors && anchors.length ? anchors : [];
      };
      var compareTwoAnchors = function compareTwoAnchors(diffs, ind1, ind2) {
        var hash1 = getAllAnchorsInDiff(diffs[ind1])[0],
          hash2 = getAllAnchorsInDiff(diffs[ind2])[0],
          anchor1 = leftAnchorTags[hash1],
          anchor2 = rightAnchorTags[hash2];
        if (anchor1.url === anchor2.url) {
          var anchorDiffs = JsDiff.diffWords(anchor1.text, anchor2.text);
          diffs[ind1].value = replaceLastOccurrence(diffs[ind1].value, hash1, "");
          diffs[ind2].value = diffs[ind2].value.replace(hash2, "");
          insertArrayIntoArray(anchorDiffs, diffs, ind2);
        } else {
          diffs[ind1].value = diffs[ind1].value.replace(hash1, anchor1.text);
          diffs[ind2].value = diffs[ind2].value.replace(hash2, anchor2.text);
        }
        delete leftAnchorTags.hash1;
        delete rightAnchorTags.hash2;
        return diffs[ind1].value;
      };
      var processRemovedAnchor = function processRemovedAnchor(hash) {
        if (!leftAnchorTags[hash]) {
          throw new Error("Anchor hash not found");
        }
        var linkText = leftAnchorTags[hash].text;
        if (linkText) {
          delete leftAnchorTags.hash;
        }
        return linkText;
      };
      var processAddedAnchor = function processAddedAnchor(hash) {
        if (!rightAnchorTags[hash]) {
          throw new Error("Anchor hash not found");
        }
        var linkText = rightAnchorTags[hash].text;
        if (linkText) {
          delete rightAnchorTags.hash;
        }
        return linkText;
      };
      var isLastAnchorInDiff = function isLastAnchorInDiff(hash, diff) {
        var anchors = getAllAnchorsInDiff(diff);
        return hash === anchors[anchors.length - 1];
      };
      var anchorPostDiffProcessing = function anchorPostDiffProcessing(diffs) {
        for (var index = 0; index < diffs.length; index++) {
          var diff = diffs[index];
          diff.value = diff.value.replace(anchorHashRegEx, function (hash) {
            if (!diff.added && !diff.removed) {
              return processUnchangedAnchor(hash);
            } else if (diff.removed && !isLastAnchorInDiff(hash, diff) && index < diffs.length - 1 && diffs[index + 1].added && getAllAnchorsInDiff(diffs[index + 1])[0]) {
              return compareTwoAnchors(diffs, index, index + 1);
            } else if (diff.removed) {
              return processRemovedAnchor(hash);
            } else if (diff.added) {
              return processAddedAnchor(hash);
            }
          });
        }
      };
      var postDiffingProcessing = function postDiffingProcessing(diffs) {
        diffs.forEach(function (diff) {
          diff.value = diff.value.replace(/<##>/g, "<br>");
          diff.value = diff.value.replace(new RegExp(URL_IMAGE_KEYWORD + "[0-9]+_", "g"), "IMAGE");
          diff.value = diff.value.replace(new RegExp(LOCAL_IMAGE_KEYWORD + "[0-9]+_", "g"), "IMAGE");
        });
        anchorPostDiffProcessing(diffs);
        return diffs;
      };
      var _diffTwoSubtrees = function diffTwoSubtrees(left, right) {
        var lc = left.getChildren(),
          rc = right.getChildren();
        var markNodesAsDifferent = function markNodesAsDifferent(lc, rc) {
          leftDiffData.changed.push(lc);
          rightDiffData.changed.push(rc);
        };
        var anyDiffFound = function anyDiffFound(diffs) {
          for (var i = 0; i < diffs.length; i++) {
            if (diffs[i].added || diffs[i].removed) {
              return true;
            }
          }
          return false;
        };
        for (var i = 0; i < lc.length; i++) {
          if (lc[i].isVisible() && rc[i].isVisible()) {
            if (lc[i].getCompareValue() != rc[i].getCompareValue()) {
              if (lc[i].type === "textarea" || lc[i].type === "textbox") {
                var leftChildValue = lc[i].value || "",
                  rightChildValue = rc[i].value || "";
                var diffs = JsDiff.diffWords(prepForDiffing("left", leftChildValue), prepForDiffing("right", rightChildValue));
                rc[i].diffs = postDiffingProcessing(diffs);
                if (anyDiffFound(diffs)) {
                  markNodesAsDifferent(lc[i], rc[i]);
                }
              } else {
                markNodesAsDifferent(lc[i], rc[i]);
              }
            }
            _diffTwoSubtrees(lc[i], rc[i]);
          } else if (lc[i].isVisible() || rc[i].isVisible()) {
            var leftShown = lc[i].isVisible();
            if (leftShown) {
              rightDiffData.hidden.push(rc[i]);
            } else {
              leftDiffData.hidden.push(lc[i]);
            }
          }
        }
      };
      if (!this.getPreviousFormController().getEmptyAnswers()) {
        _diffTwoSubtrees(leftSection, rightSection);
      }
      leftSection._diffData = leftDiffData;
      rightSection._diffData = rightDiffData;
    }
  };
  module.exports = DiffCalculator;
});

